import React from 'react' 
import useSEO from "./useSEO";

const Maramiaccounting = () => {
  useSEO({ 
  title: "Marami Accounting Software | Comprehensive Business Accounting Solutions",
  description: "Optimize your business accounting with Marami Accounting Software. Manage financial records, billing, inventory, payroll, and reporting with an easy-to-use and reliable platform.",
  keywords: "Marami accounting software, business accounting solutions, Marami ERP, Marami billing software, Marami inventory management, Marami payroll, Marami bookkeeping, financial reporting software",
  ogTitle: "Marami Accounting Software - Reliable Business Accounting",
  ogDescription: "Streamline your accounting, billing, and financial reporting with Marami.",
  ogImage: "img/marami-accounting.png",
  twitterTitle: "Marami Accounting Software - Reliable Business Accounting",
  twitterDescription: "Simplify and optimize your business financial operations with Marami Accounting Software.",
  twitterImage: "img/marami-accounting.png"
});

  return (
    <div>

        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Marami Accounting Software </h1>
          <p className="mb-4">
            {" "}
            Marami Accounting Software is a powerful, user-centric financial
            management solution designed to simplify and streamline all your
            accounting operations. Whether you're managing day-to-day
            transactions or generating complex financial reports, Marami offers
            an intuitive and customizable platform tailored to meet the needs of
            small to mid-sized businesses.{" "}
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/marami-accounting1.png"
            alt="Marami Accounting Software"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/marami-accounting.png"
              alt="Marami Accounting Software"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Complete Financial Accounting:</b>
                </li>
                <p>
                  {" "}
                  Manage general ledger, accounts receivable/payable, journal
                  entries, and trial balances with ease.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> GST &amp; Tax Compliance: </b>
                </li>
                <p>
                  {" "}
                  Generate GST-compliant invoices, auto-calculate taxes, and
                  prepare returns as per local regulations.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Billing &amp; Invoicing: </b>
                </li>
                <p>
                  {" "}
                  Create professional invoices, handle multi-currency billing,
                  and track payments efficiently.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Inventory Control:</b>
                </li>
                <p>
                  {" "}
                  Monitor stock levels, handle purchase/sales orders, and track
                  item movement in real time./p&gt;
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> User Access &amp; Roles: </b>
                </li>
                <p>
                  {" "}
                  Enable multiple users with role-based access to maintain data
                  security and workflow efficiency.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Insightful Reporting: </b>
                </li>
                <p>
                  {" "}
                  Access real-time dashboards and customizable reports including
                  balance sheets, profit &amp; loss statements, and cash flow
                  analysis.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Maramiaccounting
